import { Grid } from "@material-ui/core";
import { Alert } from "@mui/material";
import Authorize from "components/Authorize";
import { permissionProfiles } from "components/Authorize/permissionProfiles";
import CustomInput from "components/CustomInput";
import { useGetPriceByAssetListQuery } from "features/clients/pricingRubricSlice";
import { IconDollar } from "icons";
import LoadPricingStyles from "./LoadPricingStyles";
import { getMovementMethodFromTrailerType } from "./LoadPricingConsts";
import { useEffect, useState } from "react";

const LoadRubricPricing = ({ load, legIndex, onChange, clientId }) => {
    const classes = LoadPricingStyles();

    let loadData = legIndex >= 0 ? load?.loads[legIndex] : {};

    const miles = loadData?.miles;
    const weightClasses = (loadData?.assets ?? [])
        .map(a => a?.weightClass)
        .filter(Boolean)
        .map(String);
    const movementMethod = getMovementMethodFromTrailerType(loadData?.trailerType);

    let { data: rubricPrice, error: priceError, isLoading: isLoadingPrice } = useGetPriceByAssetListQuery(
        { clientId, miles, assetClasses: weightClasses, movementMethod },
        { skip: !clientId || !weightClasses.length || !miles || miles === 0 }
    );

    const [price, setPrice] = useState();

    useEffect(() => {
        if (rubricPrice) {
            let priceObject = { cost: rubricPrice?.internalCost?.toFixed(2), charge: rubricPrice?.price?.toFixed(2) };
            setPrice(priceObject);
            onChange(priceObject);
        }
    }, [rubricPrice]);

    const errorMessage = priceError?.data?.messages?.[0];

    return (
    <>
        <Grid container className={classes.formWrapper}>
            <Grid item xs={12} className={classes.title}>
                    Pricing
            </Grid>
            {errorMessage && (
                <Grid item xs={12}>
                    <Alert severity="warning">{errorMessage} — load will be priced manually at invoicing</Alert>
                </Grid>
            )}
            <Authorize profile={permissionProfiles.LOAD.LOAD_EDIT} >
                <Grid item xs={4} className={classes.field}>
                    <CustomInput
                        id="cost"
                        label="Estimated Cost"
                        value={rubricPrice?.internalCost?.toFixed(2) ?? ""}
                        elementType="input"
                        numberOnly
                        icon={<IconDollar />}
                        showEmpty
                        disabled
                    />
                </Grid>
            </Authorize>
            <Grid item xs={4} className={classes.field}>
                <CustomInput
                    id="charge"
                    label="Charge"
                    value={rubricPrice?.price?.toFixed(2) ?? ""}
                    elementType="input"
                    numberOnly
                    icon={<IconDollar />}
                    showEmpty
                    disabled
                />
            </Grid>
        </Grid>
    </>
    );
}

export default LoadRubricPricing;
